import { useState } from "react";
import "./SettingsModal.css";

function SettingsModal({ onClose }) {
  const [step, setStep] = useState("password"); // 'password' | 'config'
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsVerifying(true);

    if (!window.electronAPI) {
      setError("This feature only works in the desktop app");
      setIsVerifying(false);
      return;
    }

    try {
      const valid = await window.electronAPI.verifyPassword(password);
      if (valid) {
        const result = await window.electronAPI.loadConfig();
        if (result.success) {
          setApiUrl(result.data.apiUrl || "https://api.hayducate.com");
        }
        setStep("config");
      } else {
        setError("Incorrect password");
        setPassword("");
      }
    } catch (err) {
      setError("Verification failed");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleSaveConfig = async (e) => {
    e.preventDefault();
    setError("");

    if (!apiUrl.trim()) {
      setError("Please enter a valid API URL");
      return;
    }

    try {
      const result = await window.electronAPI.saveConfig({ apiUrl });
      if (result.success) {
        alert("Configuration saved! The app will now reload.");
        window.location.reload();
      } else {
        setError("Failed to save: " + result.error);
      }
    } catch (err) {
      setError("Failed to save configuration");
    }
  };

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <button className="settings-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        {step === "password" && (
          <>
            <div className="settings-icon">🔒</div>
            <h2>Admin Access</h2>
            <p className="settings-desc">
              Enter the admin password to continue
            </p>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                className="settings-input"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
                disabled={isVerifying}
              />
              {error && <div className="settings-error">{error}</div>}
              <button
                type="submit"
                className="settings-btn"
                disabled={isVerifying}
              >
                {isVerifying ? "Verifying..." : "Unlock"}
              </button>
            </form>
          </>
        )}

        {step === "config" && (
          <>
            <div className="settings-icon">⚙️</div>
            <h2>API Configuration</h2>
            <p className="settings-desc">Set the backend API URL</p>
            <form onSubmit={handleSaveConfig}>
              <label className="settings-label">API URL</label>
              <input
                type="text"
                className="settings-input"
                placeholder="https://api.hayducate.com"
                value={apiUrl}
                onChange={(e) => setApiUrl(e.target.value)}
                autoFocus
              />
              <div className="settings-hint">
                Example: https://api.hayducate.com or http://192.168.1.100:8000
              </div>
              {error && <div className="settings-error">{error}</div>}
              <button type="submit" className="settings-btn">
                Save Configuration
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default SettingsModal;